import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bcbf0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qrcode" }
const _hoisted_2 = {
  id: "qrcodeCanvas",
  ref: "canvas"
}
const _hoisted_3 = { class: "copy-link-container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note" }, "このリンクをメールやLINE等に貼り付けてご家族と共有頂くことができます", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RandselDialog = _resolveComponent("RandselDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_RandselDialog, {
    ref: "root",
    title: "共有リンク",
    showEventName: _ctx.getShowEventName,
    class: "copylink-dialog",
    onOnShow: _ctx.onShow
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("canvas", _hoisted_2, null, 512)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("code", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.link,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, null, 8, _hoisted_4),
        _hoisted_5
      ])), [
        [_directive_tooltip, { content: '共有リンクをコピーする', placement: 'bottom' }]
      ]),
      _hoisted_6
    ]),
    _: 1
  }, 8, ["showEventName", "onOnShow"]))
}